import { Component, OnInit } from '@angular/core';
import {RoutesConst} from '@carm/shared/constants/const-routes';
import { last, take, takeUntil } from 'rxjs/operators';
import { setDateWithOffset } from '@carm/shared/functions/common-functions';
import { combineLatest } from 'rxjs';
import { DashboardCountService } from '@carm/_core/dashboard-count/services/dashboard-count.service';
import * as dayjs from 'dayjs';
import { dateFormat } from '@carm/shared/constants/const-carm';
import { CarmRouter } from '@carm/_core/carm-router/services/carm-router.service';
import { BaseComponent } from '@carm/_utils/base.component';

@Component({
  selector: 'carm-commercial-accounting',
  templateUrl: './commercial-accounting.component.html',
  styleUrls: ['./commercial-accounting.component.scss']
})
export class CommercialAccountingComponent extends BaseComponent implements OnInit {

  public commericalAccounting: number;
  public viewAllCommericalAccountingUrl: string;
  public days = 5;
  public loading = true;

  constructor(
    private dashboardCountService: DashboardCountService,
    private carmRouter: CarmRouter) {
    super();
  }

  ngOnInit(): void {
    this.viewAllCommericalAccountingUrl = RoutesConst.Declarations_Mgt_NewDeclarations;
    this.commericalAccounting;
    this.getDeclarationsCount();
  }

  private getDeclarationsCount() {
    const maxDate = setDateWithOffset(0, 0, 0);

    combineLatest([
      this.carmRouter.bn9$,
      this.carmRouter.bn15$,
    ])
    .pipe(take(1),takeUntil(this.destroy$))
    .subscribe(([bn9, programId]) => {

      this.loading = true;
      const minDate = dayjs('1900-01-01', dateFormat).toDate();

      this.dashboardCountService.getCadReleaseCount(bn9, programId, minDate, maxDate)
      .pipe(takeUntil(this.destroy$), last())
      .subscribe(getCadReleaseCountResponse => {
        this.loading = false;
        this.commericalAccounting = getCadReleaseCountResponse?.recordCount || 0;
      }, () => { this.loading = false; });

    }, () => this.loading = false);
  }
}
